import { render, staticRenderFns } from "./SequenceEvaluationsDetails.vue?vue&type=template&id=589e586f&scoped=true"
import script from "./SequenceEvaluationsDetails.vue?vue&type=script&lang=js"
export * from "./SequenceEvaluationsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e586f",
  null
  
)

export default component.exports